import { createContext, useContext } from 'react';

// Owned by the mounted support boundary, never storage or a cross-session cache.
// Only the initial route may reuse this freshly verified identity. API calls
// continue to authorize the delegated session independently on the server.
export const NativeSupportBootstrap = createContext(null);
export const useNativeSupportBootstrap = () => useContext(NativeSupportBootstrap);
